export default "/_next/static/images/img4-41abecec7a58090c23123ee9cd88e225.png";